import roses from '../images/prints/roses.png';
import artwork0 from '../images/prints/artwork0.jpg';
import artwork1 from '../images/prints/artwork5.jpg';
import artwork1png from '../images/prints/artwork1.png';
import artwork3jpg from '../images/prints/artwork3.jpg';
import artwork4jpg from '../images/prints/artwork4.jpg';
import artwork6jpg from '../images/prints/artwork6.jpg';
import bunnyart from '../images/prints/bunnyart.jpg';
import miffysLesson from '../images/prints/Miffys_Lesson.png';
import lklkl from '../images/prints/lklkl.png';
import mknkn from '../images/prints/mknkn.png';
import zxzxz from '../images/prints/zxzxz.png';
import artwork3png from '../images/stickers/artwork3.png';
import artwork4png from '../images/stickers/artwork4.png';
import sticker6 from '../images/stickers/sticker6.png';
import sticker7 from '../images/stickers/sticker7.png';
import sticker8 from '../images/stickers/sticker8.png';
import sticker9 from '../images/stickers/sticker9.png';
import sticker11 from '../images/stickers/sticker11.png';
import mochaSitting from '../images/stickers/sheets/Mocha_Sitting_Final_No_1.png';
import movhaSnowboarder from '../images/stickers/sheets/Movha_Snowboarder_Final_No_1.png';
import crochet1a from '../images/crochet/crocet1a.jpeg';

export const IMAGE_MAP = {
  '/prints/roses.png': roses,
  '/prints/artwork0.jpg': artwork0,
  '/prints/artwork5.jpg': artwork1,
  '/prints/artwork1.png': artwork1png,
  '/prints/artwork3.jpg': artwork3jpg,
  '/prints/artwork4.jpg': artwork4jpg,
  '/prints/artwork6.jpg': artwork6jpg,
  '/prints/bunnyart.jpg': bunnyart,
  '/prints/Miffys_Lesson.png': miffysLesson,
  '/prints/lklkl.png': lklkl,
  '/prints/mknkn.png': mknkn,
  '/prints/zxzxz.png': zxzxz,
  '/stickers/artwork3.png': artwork3png,
  '/stickers/artwork4.png': artwork4png,
  '/stickers/sticker6.png': sticker6,
  '/stickers/sticker7.png': sticker7,
  '/stickers/sticker8.png': sticker8,
  '/stickers/sticker9.png': sticker9,
  '/stickers/sticker11.png': sticker11,
  '/stickers/sheets/Mocha_Sitting_Final_No_1.png': mochaSitting,
  '/stickers/sheets/Movha_Snowboarder_Final_No_1.png': movhaSnowboarder,
  '/crochet/crocet1a.jpeg': crochet1a,
};

export const resolveImage = (path) => IMAGE_MAP[path] || require('../images' + path);
